<section class="wrapper">
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h1 class="modalTitle">
      <mat-icon class="iconPosition">info_outline</mat-icon>
      Extra Info
    </h1>
  </section>
  <section mat-dialog-content>
    @if (loading) {
      <section class="loading">
        <mat-icon>autorenew</mat-icon>
        Loading&hellip;
      </section>
    }

    @if (!loading) {
      <div cdkDropListGroup>
        <section class="add-new-container">
          <button (click)="editItem()" mat-button matTooltip="Add info.">
            Add new
            <mat-icon>add</mat-icon>
          </button>
        </section>
        <div class="list-container">
          <h2>
            Tab - top of page
            <mat-icon>vertical_align_top</mat-icon>
          </h2>
          <div
            (cdkDropListDropped)="drop($event)"
            [cdkDropListData]="paymentData"
            cdkDropList
            class="extra-info-list"
            id="payment"
            >
            @for (item of paymentData; track item) {
              <div cdkDrag class="extra-info-item">
                <p>{{item.title}}</p>
                <button
                  (click)="editItem(item)"
                  mat-icon-button
                  matTooltip="Edit info."
                  >
                  <mat-icon>edit</mat-icon>
                </button>
                <button
                  (click)="deleteItem(item)"
                  mat-icon-button
                  matTooltip="Delete info."
                  >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            }
          </div>
        </div>
        <div class="list-container">
          <h2>
            Drop down box - bottom of page
            <mat-icon>vertical_align_bottom</mat-icon>
          </h2>
          <div
            (cdkDropListDropped)="drop($event)"
            [cdkDropListData]="productData"
            cdkDropList
            class="extra-info-list"
            id="product"
            >
            @for (item of productData; track item) {
              <div cdkDrag class="extra-info-item">
                <p>{{item.title}}</p>
                <button
                  (click)="editItem(item)"
                  mat-icon-button
                  matTooltip="Edit info."
                  >
                  <mat-icon>edit</mat-icon>
                </button>
                <button
                  (click)="deleteItem(item)"
                  mat-icon-button
                  matTooltip="Delete info."
                  >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </section>
</section>
